import type { HTMLAttributes, ReactElement } from 'react';
import { isShortLabel } from './label.js';

/** Plain-text tags up to this length are set in the pixel display face. */
const DISPLAY_LABEL_MAX = 8;

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export function Badge({
  tone = 'neutral',
  className,
  children,
  ...props
}: BadgeProps): ReactElement {
  return (
    <span
      {...props}
      className={[
        'cards-kit-badge',
        `cards-kit-badge--${tone}`,
        isShortLabel(children, DISPLAY_LABEL_MAX) ? 'cards-kit-badge--display' : undefined,
        className,
      ].filter(Boolean).join(' ')}
    >
      {children}
    </span>
  );
}
